import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { YodleeConsentApiPayload } from '../interface/finapp-consent.interface';

@Injectable()
export class FinappConsentService {

  constructor(
    private http: HttpClient,
  ) { }

  public getConsentInfo(): Observable<any> {
    const baseApi = '/api/secure';
    const url = baseApi + '/bycp-platform/v1/consent/yodlee';
    const headers: HttpHeaders = new HttpHeaders().append('Content-Type', 'application/json');

    return this.http
      .get(url, { headers: headers }).pipe(
        map(response => response)
        , catchError(error => {
          let message = error.statusText === '' ? 'An error occurred during the request.' : error.statusText;
          return throwError(message);
        }));
  }

  public saveConsentInfo(consentPayload: YodleeConsentApiPayload): Observable<any> {
    const baseApi = '/api/secure';
    const url = baseApi + '/bycp-platform/v1/consent/yodlee';
    const headers: HttpHeaders = new HttpHeaders().append('Content-Type', 'application/json');

    const body: string = JSON.stringify(consentPayload);

    return this.http
      .put(url, body, { headers: headers, observe: 'response' }).pipe(map(response => response), catchError(error => {
        let message = error.statusText === '' ? 'An error occurred during the request.' : error.statusText;
        return throwError(message);
      }));
  }
}
